/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratPillar,
    JsonStratPillarFromJSON,
    JsonStratPillarFromJSONTyped,
    JsonStratPillarToJSON,
} from './JsonStratPillar';

/**
 * 
 * @export
 * @interface ApiResultOfJsonStratPillar
 */
export interface ApiResultOfJsonStratPillar {
    /**
     * 
     * @type {JsonStratPillar}
     * @memberof ApiResultOfJsonStratPillar
     */
    data?: JsonStratPillar;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillar
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonStratPillar
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillar
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonStratPillar
     */
    result?: ApiResultOfJsonStratPillarResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonStratPillarResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonStratPillarFromJSON(json: any): ApiResultOfJsonStratPillar {
    return ApiResultOfJsonStratPillarFromJSONTyped(json, false);
}

export function ApiResultOfJsonStratPillarFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonStratPillar {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonStratPillarFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonStratPillarToJSON(value?: ApiResultOfJsonStratPillar | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonStratPillarToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

